import {
    Layout,
    Button,
    Tree,
    Menu,
    Dropdown,
    Input,
    Modal,
    Checkbox,
    Pagination,
    message,
} from 'antd';
import {
    getEnterpriseFolders,
    createEnterpriseFolder,
    editEnterpriseFolder,
    editEnterpriseFolderImgName,
    editEnterpriseLibraryResource,
    moveEnterpriseLibraryResource,
    getEnterpriseModels,
    sortEnterpriseFolders,
} from '@/api/hdd/ceiling';
import CeilingBar from '@/components/CeilingBar';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import React, {
    useContext,
    useEffect,
    useReducer,
    useRef,
    useState,
} from 'react';
import { LoadingContext } from '&/components/LoadingComponent';
import CeilingModals from '@/components/CeilingModals';
import { debounce } from 'lodash';
import intl from 'react-intl-universal';
import { useHistory } from 'react-router-dom';
import '../index.scss';

const { Header, Sider, Content } = Layout;
const { Item } = Menu;
const { DirectoryTree } = Tree;

export default function CustomPublicManage() {
    const loadingContext = useContext(LoadingContext);
    const history = useHistory();

    const ceilingBar = useRef();
    const hasInput = useRef(false);
    const selectFlag = useRef(true);
    const currentNode = useRef(null);

    const [showCheckBox, setShowCheckBox] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [detailOpen, setDetailOpen] = useState(false);
    const [moveOpen, setMoveOpen] = useState(false);
    const [detail, setDetail] = useState({});
    const [folderCode, setFolderCode] = useState('');
    const [keyword, setKeyword] = useState('');
    const [order, setOrder] = useState('');
    const [store, setStore] = useState(undefined);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [treeData, setTreeData] = useState([]);
    const [moveTreeData, setMoveTreeData] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [parentId, setParentId] = useState(undefined);
    const [list, setList] = useState([]);
    console.log('parentId', parentId);

    const [didUpdate, forceUpdate] = useReducer(s => s + 1, 0);

    useEffect(() => {
        didUpdate > 0 && getResourceList();
    }, [didUpdate]);

    useEffect(() => {
        if (treeData.length === 0) return;

        const moveTree = JSON.parse(JSON.stringify(treeData));
        formatMoveTreeData(moveTree);
        setMoveTreeData(moveTree);
    }, [treeData]);

    const getFolderData = () => {
        return getEnterpriseFolders().then(res => {
            const raw = Array.isArray(res?.data)
                ? res.data
                : res?.data?.list || [];

            const tree = Array.isArray(raw) ? raw : [];

            formatTreeData(tree);

            setTreeData(tree);

            return tree;
        });
    };

    useEffect(() => {
        getFolderData().then(tree => {
            if (!tree || tree.length === 0) {
                setTreeData([]);
                return;
            }

            setParentId(tree[0].id);
            setFolderCode(tree[0].code);
            forceUpdate();
            setExpandedKeys(tree.map(item => item.key));
        });

        const handleDocumentClick = e => {
            if (!hasInput.current) return;

            if (
                e.target.classList.contains('edit-wrap') ||
                e.target.classList.contains('edit-input')
            ) {
                return;
            } else if (e.target.classList.contains('more-visible')) {
                return;
            } else {
                onSave(currentNode.current);
            }
        };

        document.addEventListener('click', handleDocumentClick);

        document.oncontextmenu = function (event) {
            event.preventDefault();
        };

        window.freshData = () => {
            forceUpdate();
        };

        return () => {
            document.removeEventListener('click', handleDocumentClick);
            document.oncontextmenu = null;
        };
    }, []);

    const changeNode = (key, value, data) =>
        data.forEach(item => {
            if (item.key === key) {
                item.value = value;
            }
            if (item.children) {
                changeNode(key, value, item.children);
            }
        });

    const onChange = (e, key) => {
        e.stopPropagation();
        changeNode(key, e.target.value, treeData);
        setTreeData([...treeData]);
    };

    const formatTreeData = (obj, level = 1) => {
        for (const i in obj) {
            obj[i].isEditable = false;
            obj[i].value = obj[i].name;
            obj[i].defaultValue = obj[i].name;
            obj[i].title = obj[i].value;
            obj[i].key = obj[i].code;
            obj[i].nodeCode = obj[i].code;
            obj[i].nodeId = obj[i].id;
            obj[i].level = level;
            obj[i].className = level >= 2 ? `tree-level-${level}` : undefined;
            obj[i].children =
                obj[i].son && obj[i].son.length > 0 ? obj[i].son : [];
            if (obj[i].children && obj[i].children.length > 0) {
                formatTreeData(obj[i].children, level + 1);
                obj[i].isLeaf = false;
            } else {
                obj[i].isLeaf = true;
            }
        }
    };

    const formatMoveTreeData = (obj, level = 1) => {
        for (const i in obj) {
            obj[i].isEditable = false;
            obj[i].value = obj[i].name;
            obj[i].defaultValue = obj[i].name;
            obj[i].title = obj[i].value;
            obj[i].key = obj[i].id;
            obj[i].nodeCode = obj[i].code;
            obj[i].nodeId = obj[i].id;
            obj[i].level = level;
            obj[i].className = level >= 2 ? `tree-level-${level}` : undefined;
            obj[i].children =
                obj[i].son && obj[i].son.length > 0 ? obj[i].son : [];
            if (obj[i].children && obj[i].children.length > 0) {
                formatMoveTreeData(obj[i].children, level + 1);
                obj[i].isLeaf = false;
            } else {
                obj[i].isLeaf = true;
            }
            obj[i].selectable = level > 1 && obj[i].isLeaf;
        }
    };

    const removeNodeByKey = (nodes, key) => {
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            if (node.key === key) {
                const [removed] = nodes.splice(i, 1);
                return removed;
            }
            if (node.children && node.children.length > 0) {
                const removed = removeNodeByKey(node.children, key);
                if (removed) {
                    return removed;
                }
            }
        }
        return null;
    };

    const findSiblingsByKey = (nodes, key) => {
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].key === key) {
                return nodes;
            }
            if (nodes[i].children && nodes[i].children.length > 0) {
                const result = findSiblingsByKey(nodes[i].children, key);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    };

    const buildFolderSortPayload = nodes => {
        const folderSort = [];
        const traverse = currentNodes => {
            currentNodes.forEach((node, index) => {
                folderSort.push({ id: node.id, sort: index });
                if (node.children && node.children.length > 0) {
                    traverse(node.children);
                }
            });
        };
        traverse(nodes);
        return folderSort;
    };

    const persistFolderSort = updatedTree => {
        const folderSort = buildFolderSortPayload(updatedTree);
        console.log('folderSort', folderSort);
        sortEnterpriseFolders({ folderSort: JSON.stringify(folderSort) }).catch(
            () => {
                message.error('保存排序失败');
            }
        );
    };

    const onTreeDrop = info => {
        if (info.node.key === info.dragNode.key) {
            return;
        }

        // if (!info.dropToGap) {
        //     console.log('info.dropToGap', info.dropToGap);
        //     message.warning('仅支持同级排序');
        //     return;
        // }

        const dragParentPos = info.dragNode.pos
            .split('-')
            .slice(0, -1)
            .join('-');
        const dropParentPos = info.node.pos.split('-').slice(0, -1).join('-');

        if (dragParentPos !== dropParentPos) {
            message.warning('仅支持同级排序');
            return;
        }

        const nextTree = JSON.parse(JSON.stringify(treeData));
        const draggedNode = removeNodeByKey(nextTree, info.dragNode.key);

        if (!draggedNode) {
            return;
        }

        const siblings = findSiblingsByKey(nextTree, info.node.key);

        if (!siblings) {
            return;
        }

        const targetIndex = siblings.findIndex(
            item => item.key === info.node.key
        );
        const relativePosition =
            info.dropPosition - Number(info.node.pos.split('-').pop());
        let insertIndex = relativePosition < 0 ? targetIndex : targetIndex + 1;
        if (insertIndex < 0) insertIndex = 0;
        if (insertIndex > siblings.length) insertIndex = siblings.length;

        siblings.splice(insertIndex, 0, draggedNode);
        setTreeData(nextTree);
        persistFolderSort(nextTree);
    };

    const onSave = nodeData => {
        if (!nodeData) return;

        selectFlag.current = true;

        loadingContext.toggleSpin();

        if (!nodeData.value) {
            message.error('请输入分类名称');

            loadingContext.toggleSpin();

            return;
        }

        const isCreate = nodeData.is_new === 1;

        const apiName = isCreate
            ? createEnterpriseFolder
            : editEnterpriseFolder;

        const params = {
            name: nodeData.value,
            pid: nodeData.pid,
            type: 23,
            folderId: nodeData.id,
        };

        if (!isCreate) {
            params.id = nodeData.id;
        }

        apiName(params)
            .then(() => {
                return getFolderData();
            })
            .catch(() => {
                setTreeData(prev => {
                    formatTreeData(prev);
                    return [...prev];
                });
            })
            .finally(() => {
                hasInput.current = false;

                loadingContext.toggleSpin();
            });
    };

    const editNode = (key, data) => {
        data.forEach(item => {
            item.isEditable = item.key === key;
            item.value = item.defaultValue;
            if (item.children) {
                item.children = editNode(key, item.children);
            }
        });
        return data;
    };

    const onEdit = (key, defaultValue, e) => {
        if (e) {
            e.domEvent.stopPropagation();
        }

        hasInput.current = true;

        setTreeData(prev => {
            let NEXT = [...prev];
            NEXT = editNode(key, NEXT);
            return NEXT;
        });
    };

    const deleteTreeNode = nodeData => {
        const params = {
            name: nodeData.value || nodeData.name,
            pid: nodeData.pid,
            type: 23,
            folderId: nodeData.id,
            id: nodeData.id,
            status: 0,
        };
        return editEnterpriseFolder(params).then(() => {
            return getFolderData();
        });
    };

    const findTopLevelAncestor = targetKey => {
        const searchInChildren = (children, key) => {
            for (const child of children) {
                if (child.key === key) return true;
                if (child.children && searchInChildren(child.children, key))
                    return true;
            }
            return false;
        };
        for (const node of treeData) {
            if (
                node.key === targetKey ||
                searchInChildren(node.children || [], targetKey)
            ) {
                return node;
            }
        }
        return null;
    };

    const onDelete = (nodeData, e) => {
        if (e) {
            e.domEvent.stopPropagation();
        }

        Modal.confirm({
            title: intl.get('base.warning'),
            icon: <ExclamationCircleOutlined />,
            content: intl.get('directory.deleteConfirm'),
            centered: true,
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            wrapClassName: 'delete-tree-node-modal',
            className: 'delete-tree-node-modal',
            onOk(close) {
                const isSelected = folderCode === nodeData.key;
                const topAncestor = isSelected
                    ? findTopLevelAncestor(nodeData.key)
                    : null;
                deleteTreeNode(nodeData)
                    .then(() => {
                        if (topAncestor && topAncestor.key !== nodeData.key) {
                            setFolderCode(topAncestor.key);
                            setParentId(topAncestor.id);
                            setPage(1);
                            forceUpdate();
                        }
                    })
                    .finally(close);
            },
        });
    };

    const onBindImgName = (nodeData, e) => {
        if (e) {
            e.domEvent?.stopPropagation();
        }

        let nextImgName = nodeData.image || '';

        Modal.confirm({
            title: '绑定图片名称',
            content: (
                <Input
                    maxLength={30}
                    defaultValue={nextImgName}
                    placeholder="请输入图片名称"
                    onChange={event => {
                        nextImgName = event.target.value;
                    }}
                />
            ),
            centered: true,
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            icon: null,
            onOk(close) {
                const imgName = nextImgName.trim();
                if (!imgName) {
                    message.warning('请输入图片名称');
                    return;
                }

                loadingContext.toggleSpin();
                editEnterpriseFolderImgName({
                    imgName,
                    folderId: nodeData.id,
                })
                    .then(() => {
                        message.success('绑定图片名称成功');
                        return getFolderData();
                    })
                    .then(() => {
                        close();
                    })
                    .catch(() => {
                        message.error('绑定图片名称失败');
                    })
                    .finally(() => {
                        loadingContext.toggleSpin();
                    });
            },
        });
    };

    const onAdd = (nodeData, e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        if (!expandedKeys.includes(nodeData.key)) {
            const next = JSON.parse(JSON.stringify(expandedKeys));
            next.push(nodeData.key);
            setExpandedKeys(next);
        }

        // 产品库（第一个一级分类）直接子类不能超过10个
        if (
            nodeData.level === 1 &&
            treeData[0] &&
            nodeData.key === treeData[0].key
        ) {
            const savedChildren = (nodeData.children || []).filter(
                c => c.is_new !== 1
            );
            if (savedChildren.length >= 10) {
                message.warning('子类不能超过10个');
                return;
            }
        }

        if (hasInput.current) {
            onSave(currentNode.current);

            return;
        }

        setTreeData(prev => {
            let NEXT = [...prev];
            NEXT = addNode(nodeData, NEXT);
            return NEXT;
        });
        hasInput.current = true;
    };

    const onAddDebounce = debounce(onAdd, 500);

    const addNode = (nodeData, data) => {
        data.forEach(item => {
            if (item.key === nodeData.key) {
                item.children = item.children || [];
                const nextLevel = (nodeData.level || 0) + 1;
                item.children.push({
                    key: item.key + Math.random(),
                    value: '未命名',
                    defaultValue: '未命名',
                    isEditable: true,
                    is_new: 1,
                    pid: nodeData.id,
                    level: nextLevel,
                    className:
                        nextLevel >= 2 ? `tree-level-${nextLevel}` : undefined,
                    children: [],
                    isLeaf: true,
                });
                item.isLeaf = false;
            }
            if (item.children) {
                addNode(nodeData, item.children);
            }
        });
        return data;
    };

    const titleMenu = nodeData => {
        const canAddSubClass = [2, 3].includes(nodeData.level) && !!nodeData.id;
        const isOriginNode = +nodeData.isOrigin === 1;
        const canRename = !isOriginNode;
        const canDelete = !isOriginNode;
        const productLibraryId = treeData[0]?.id;
        const isProductLibrarySecondLevel =
            nodeData.level === 2 &&
            !!nodeData.id &&
            productLibraryId !== undefined &&
            String(nodeData.pid) === String(productLibraryId);

        return (
            <Menu>
                {canAddSubClass && (
                    <Menu.Item
                        key="add"
                        onClick={e => {
                            e.domEvent?.stopPropagation();
                            onAddDebounce(nodeData);
                        }}>
                        新建子类
                    </Menu.Item>
                )}
                {canRename && (
                    <Menu.Item
                        key="rename"
                        onClick={e =>
                            onEdit(nodeData.key, nodeData.defaultValue, e)
                        }>
                        重命名
                    </Menu.Item>
                )}
                {canDelete && (
                    <Menu.Item
                        key="delete"
                        onClick={e => onDelete(nodeData, e)}>
                        删除
                    </Menu.Item>
                )}
                {isProductLibrarySecondLevel && (
                    <Menu.Item
                        key="bind-img-name"
                        onClick={e => onBindImgName(nodeData, e)}>
                        绑定图片名称
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const titleRender = nodeData => {
        const isSecondLevel = nodeData.level === 2 && !!nodeData.id;
        const isThirdLevel = nodeData.level === 3 && !!nodeData.id;
        const hasChildren = nodeData.children && nodeData.children.length > 0;
        const showDropdown =
            isSecondLevel ||
            isThirdLevel ||
            (!hasChildren && +nodeData.isOrigin !== 1);
        const isExpanded = expandedKeys.includes(nodeData.key);

        const handleToggleExpand = e => {
            e.stopPropagation();
            setExpandedKeys(prev => {
                const nextSet = new Set(prev);
                if (nextSet.has(nodeData.key)) {
                    nextSet.delete(nodeData.key);
                } else {
                    nextSet.add(nodeData.key);
                }
                return Array.from(nextSet);
            });
        };

        if (nodeData.isEditable) {
            return (
                <span
                    onClick={e => e.stopPropagation()}
                    className="edit-wrap"
                    style={{ overflow: 'hidden' }}>
                    <Input
                        ref={input => {
                            if (input != null) {
                                if (selectFlag.current) {
                                    selectFlag.current = false;
                                    input.select();
                                }
                                input.focus();
                                currentNode.current = nodeData;
                            }
                        }}
                        maxLength={30}
                        size="mini"
                        className="edit-input"
                        value={nodeData.value}
                        onChange={e => onChange(e, nodeData.key)}
                        onPressEnter={() => onSave(nodeData)}
                    />
                </span>
            );
        } else {
            return (
                <>
                    <div className="left">
                        {(isSecondLevel || isThirdLevel) && hasChildren && (
                            <span
                                className={`toggle-expand-btn ${
                                    isExpanded ? 'expanded' : 'collapsed'
                                } ${
                                    folderCode === nodeData.key ? 'active' : ''
                                }`}
                                onClick={handleToggleExpand}
                            />
                        )}
                        <div className="text-wrap">
                            <div className="hide-text">{nodeData.value}</div>
                            <div className={`text-no-wrap title`}>
                                {nodeData.value}
                            </div>
                        </div>
                    </div>
                    {nodeData.level === 1 && !isSecondLevel && (
                        <i
                            className="icon-plus outlined more more-visible"
                            onClick={e => {
                                e.stopPropagation();
                                onAddDebounce(nodeData, e);
                            }}></i>
                    )}
                    {showDropdown && (
                        <Dropdown
                            overlay={titleMenu(nodeData)}
                            trigger={['click']}
                            getPopupContainer={() =>
                                document.querySelector('.ceiling-tree')
                            }
                            className="directory-dropdown">
                            <i
                                className="icon-more-h filled more"
                                onClick={event => handleMore(event)}></i>
                        </Dropdown>
                    )}
                </>
            );
        }
    };

    const handleMore = e => {
        e.stopPropagation();
        e.preventDefault();
    };

    const onSelect = (keys, info) => {
        setPage(1);
        setFolderCode(info.node.nodeCode);
        setParentId(info.node.nodeId || info.node.id);
        forceUpdate();
    };

    const getResourceList = () => {
        const params = {
            folderCode: folderCode,
            keyword,
            order,
            store,
            page,
            type: 7,
            pageSize: 24,
        };

        Object.keys(params).forEach(key => {
            if (params[key] === undefined || params[key] === '') {
                delete params[key];
            }
        });

        getEnterpriseModels(params).then(res => {
            const data = res?.data || {};
            const rawList = Array.isArray(data.item)
                ? data.item
                : data.rows || [];

            const nextList = rawList.map(item => ({
                ...item,
                selectedAll: false,
            }));
            setList(nextList);

            const totalCount = data.page?.totalList ?? nextList.length;
            setTotal(totalCount);
        });
    };

    const onClickImage = item => {
        // const obj = {
        //     xmlFile: item.filePath,
        //     title: item.name || item.fileName,
        //     sourceCode: item.code,
        // };
        // try {
        //     window.external.DispatchFun(
        //         'XmlEditor',
        //         'DownLoadProject',
        //         JSON.stringify(obj)
        //     );
        // } catch (e) {
        //     Promise.reject(e);
        // }
    };

    const onCheckBoxChange = (e, item) => {
        setList(
            list.map(i => {
                if (i.id === item.id) {
                    i.selectedAll = e.target.checked;
                }
                return i;
            })
        );
    };

    useEffect(() => {
        if (ceilingBar.current) {
            if (!list || list.length === 0) {
                ceilingBar.current.setSelectedAll(false);
            } else {
                ceilingBar.current.setSelectedAll(
                    list.every(item => item.selectedAll)
                );
            }
            ceilingBar.current.setIndeterminate(
                list.some(item => item.selectedAll) &&
                    !list.every(item => item.selectedAll)
            );
        }
    }, [list]);

    const viewDetailItem = item => {
        setDetailOpen(true);
    };

    const editInfoItem = item => {
        setEditOpen(true);
    };

    const upShelfItem = item => {
        editEnterpriseLibraryResource({
            modelList: [{ sourceCode: item.code, store: 1 }],
        }).then(() => {
            message.success('上架成功');
            forceUpdate();
        });
    };

    const downShelfItem = item => {
        editEnterpriseLibraryResource({
            modelList: [{ sourceCode: item.code, store: 0 }],
        }).then(() => {
            message.success('下架成功');
            forceUpdate();
        });
    };

    const moveItem = () => {
        setMoveOpen(true);
    };

    const deleteItem = () => {
        setDeleteOpen(true);
    };

    const handleClickMenu = (e, item) => {
        const actionOjb = {
            0: viewDetailItem,
            1: editInfoItem,
            2: upShelfItem,
            3: moveItem,
            4: deleteItem,
            5: downShelfItem,
        };

        setDetail(item);

        actionOjb[e.key](item);
    };

    const menu = item => (
        <Menu onClick={e => handleClickMenu(e, item)}>
            <Item key={0}>查看详情</Item>
            <Item key={1}>编辑信息</Item>
            {+item.store !== 1 ? (
                <Item key={2}>上架</Item>
            ) : (
                <Item key={5}>下架</Item>
            )}
            <Item key={3}>移动</Item>
            {/*  <Item key={4}>删除</Item> */}
        </Menu>
    );

    const onMultiDelete = () => {
        const id = list.filter(item => item.selectedAll).map(item => item.id);
        setDetail({ id });
        setDeleteOpen(true);
    };

    const onMultiMove = () => {
        const codes = list
            .filter(item => item.selectedAll)
            .map(item => item.code);
        setDetail({ code: codes });
        setMoveOpen(true);
    };

    const onMultiUpShelf = async () => {
        try {
            const items = list.filter(
                item => item.selectedAll && +item.store === 0
            );

            if (items.length === 0) return;

            const modelList = items.map(item => ({
                sourceCode: item.code,
                store: 1,
            }));

            await editEnterpriseLibraryResource({ modelList });

            message.success(`批量上架成功，共${items.length}个项目`);
            forceUpdate();
            ceilingBar.current?.setIsShowOperateBtn(false);
        } catch (error) {
            message.error('批量上架失败');
        }
    };

    const onMultiDownShelf = async () => {
        try {
            const items = list.filter(
                item => item.selectedAll && +item.store === 1
            );

            if (items.length === 0) return;

            const modelList = items.map(item => ({
                sourceCode: item.code,
                store: 0,
            }));

            await editEnterpriseLibraryResource({ modelList });

            message.success(`批量下架成功，共${items.length}个项目`);
            forceUpdate();
            ceilingBar.current?.setIsShowOperateBtn(false);
        } catch (error) {
            message.error('批量下架失败');
        }
    };

    const onExit = () => {
        history.goBack();
    };

    const onPageChange = (nextPage, pageSize) => {
        setPage(nextPage);
        forceUpdate();
    };

    const getParentNode = (currentElement, parentClass) => {
        let parentElement = currentElement.parentNode;
        while (parentElement) {
            if (parentElement.classList.contains(parentClass)) {
                break;
            }
            parentElement = parentElement.parentNode;
        }
        return parentElement;
    };

    const triggerCheckBox = e => {
        const parent = getParentNode(e.target, 'card');
        parent.querySelector('input').click();
    };

    const onExpand = keys => {
        setExpandedKeys(keys);
    };

    return (
        <div className="ceiling-component-manage">
            <Layout>
                <Header>
                    <div className="header-title">部件编辑器-公库</div>
                    <div className="btn-wrap">
                        <Button className="btn" onClick={onExit}>
                            退出
                        </Button>
                    </div>
                </Header>
                <Layout>
                    <Sider width={220} className="ceiling-tree custom-tree">
                        {treeData.length > 0 && (
                            <DirectoryTree
                                treeData={treeData}
                                defaultExpandAll
                                titleRender={titleRender}
                                onSelect={onSelect}
                                selectedKeys={[folderCode]}
                                expandedKeys={expandedKeys}
                                onExpand={onExpand}
                                draggable
                                onDrop={onTreeDrop}
                            />
                        )}
                    </Sider>
                    <Content>
                        <div className="filter">
                            <CeilingBar
                                ref={ceilingBar}
                                onIsShowOperateBtnChange={flag =>
                                    setShowCheckBox(flag)
                                }
                                onSearch={value => {
                                    setKeyword(value);
                                    setPage(1);
                                    forceUpdate();
                                }}
                                onOrder={value => {
                                    setOrder(value);
                                    forceUpdate();
                                }}
                                onCheckBoxChange={value => {
                                    setStore(value);
                                    setPage(1);
                                    forceUpdate();
                                }}
                                list={list}
                                setList={setList}
                                onMultiDelete={onMultiDelete}
                                onMultiMove={onMultiMove}
                                onMultiUpShelf={onMultiUpShelf}
                                onMultiDownShelf={onMultiDownShelf}
                                showDelete={false}
                            />
                        </div>
                        {list.length > 0 ? (
                            <>
                                <div className="card-wrap">
                                    {list.map(item => (
                                        <div className="card" key={item.id}>
                                            <div
                                                className="card-img"
                                                onClick={e =>
                                                    showCheckBox
                                                        ? triggerCheckBox(e)
                                                        : onClickImage(item)
                                                }
                                                style={{
                                                    backgroundImage: `url(${item.thumbnail})`,
                                                    color: '#fff',
                                                }}>
                                                {+item.store === 0 && (
                                                    <div className="tip">
                                                        <img
                                                            src={
                                                                require('@/assets/img/hdd/approval.png')
                                                                    .default
                                                            }></img>
                                                        <span>待上架</span>
                                                    </div>
                                                )}
                                                {showCheckBox && (
                                                    <Checkbox
                                                        onChange={e =>
                                                            onCheckBoxChange(
                                                                e,
                                                                item
                                                            )
                                                        }
                                                        onClick={e =>
                                                            e.stopPropagation()
                                                        }
                                                        checked={
                                                            item.selectedAll
                                                        }></Checkbox>
                                                )}
                                            </div>
                                            <div className="bottom-wrap">
                                                <div className="card-title">
                                                    {item.name}
                                                </div>
                                                <div className="card-btn-wrap">
                                                    <Dropdown
                                                        overlay={menu(item)}>
                                                        <span className="filled icon-more-h"></span>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <Pagination
                                    total={total}
                                    showTotal={count => `共 ${count} 条`}
                                    pageSize={24}
                                    current={page}
                                    responsive={false}
                                    showSizeChanger={false}
                                    onChange={onPageChange}
                                />
                            </>
                        ) : (
                            <div className="no-data">
                                <div>
                                    <img
                                        src={
                                            require('@/assets/img/hdd/empty-1.png')
                                                .default
                                        }></img>
                                    <div className="desc">暂无相关模型</div>
                                </div>
                            </div>
                        )}
                    </Content>
                </Layout>
            </Layout>

            <CeilingModals
                detail={detail}
                deleteOpen={deleteOpen}
                setDeleteOpen={setDeleteOpen}
                moveOpen={moveOpen}
                setMoveOpen={setMoveOpen}
                editOpen={editOpen}
                setEditOpen={setEditOpen}
                detailOpen={detailOpen}
                setDetailOpen={setDetailOpen}
                treeData={moveTreeData}
                forceUpdate={forceUpdate}
                setPage={setPage}
                list={list}
                editResourceApi={editEnterpriseLibraryResource}
                moveResourceApi={moveEnterpriseLibraryResource}
                isCustomPublic={true}
                folderId={parentId}
            />
        </div>
    );
}
